<template>
  <div class="response card">
    <div class="card-body">
      <h4 class="card-title text-primary mb-3" @click="readMore">
        {{ response.title }}
        <span>(ocena preko {{ response.score }})</span>
      </h4>
      <div class="card-text" v-html="text"></div>
    </div>
    <div class="card-footer">
      <button
        v-if="!read_more"
        class="btn btn-sm btn btn-link text-primary"
        @click.prevent="readMore"
      >Pročitaj više</button>
      <button v-else class="btn btn-sm btn-primary" @click.prevent="readLess">Pročitaj manje</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["response"],
  name: "Response",
  data() {
    return {
      read_more: false
    };
  },
  computed: {
    text: function() {
      return this.read_more
        ? this.response.text
        : this.response.text.split("\n")[0]+"...";
    }
  },
  methods: {
    readMore() {
      this.read_more = true;
    },
    readLess() {
      this.read_more = false;
    }
  }
};
</script>

<style>
.response {
  margin-bottom: 30px;
}
.text-wrapper {
  max-height: 100px;
  overflow: hidden;
  background: linear-gradient(transparent, rgba(233, 236, 239, 1));
}

.text-wrapper.active {
  max-height: 100%;
  background-attachment: none;
}

.card-body {
  transition: all 0.3s ease-in-out;
}

.card-title{
  cursor: pointer;
}
</style>